import { useState } from 'react';
import {
  TbMoodSmile, TbVirusOff, TbCar, TbGlassFull, TbMug, TbBike, TbCalculator, TbShirt,
  TbSparkles, TbBallBasketball, TbGift, TbLeaf, TbPencil, TbBallFootball, TbTool, TbHome,
  TbBulb, TbBackpack, TbDeviceGamepad2, TbKey, TbBriefcase, TbTag, TbStethoscope,
  TbDeviceUsb, TbStar, TbPaperclip, TbLayoutGrid, TbUmbrella, TbPill, TbFlag,
  TbTrafficCone, TbClock, TbPalette, TbDevices, TbBox, TbBolt,
} from 'react-icons/tb';
import '../styles/components/CategoryIcon.scss';

/** Gorra con visera, dibujada con el mismo trazo que los íconos Tabler (no hay una en el set). */
const CapIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M4 15a8 8 0 0 1 16 0" />
    <path d="M4 15h11l6 2.5a1 1 0 0 1 -.4 1.9h-16.6a1 1 0 0 1 -1 -1v-2.4z" />
    <path d="M12 7v-1" />
    <path d="M12 7c-1.5 1.5 -2 4 -2 8" />
  </svg>
);

// Slug de la categoría → ícono. Las que no estén aquí usan TbBox.
const ICONS = {
  antiestres: TbMoodSmile,
  antimicrobianos: TbVirusOff,
  automovil: TbCar,
  'bar-y-vino': TbGlassFull,
  bebidas: TbMug,
  bicicleta: TbBike,
  calculadoras: TbCalculator,
  confecciones: TbShirt,
  'cuidado-personal-y-belleza': TbSparkles,
  deportes: TbBallBasketball,
  'dias-especiales': TbGift,
  ecologia: TbLeaf,
  escritura: TbPencil,
  futbol: TbBallFootball,
  gorras: CapIcon,
  herramientas: TbTool,
  hogar: TbHome,
  iluminacion: TbBulb,
  'infantil-jovenes-escolar': TbBackpack,
  'juegos-and-entretenimiento': TbDeviceGamepad2,
  llaveros: TbKey,
  'maletines-and-bolsos': TbBriefcase,
  marcas: TbTag,
  'medicos-and-farmaceuticos': TbStethoscope,
  'memorias-usb': TbDeviceUsb,
  'nuevos-productos': TbStar,
  oficina: TbPaperclip,
  otros: TbLayoutGrid,
  'ver-otros': TbLayoutGrid,
  'paraguas-e-impermeables': TbUmbrella,
  pharma: TbPill,
  'produccion-nacional': TbFlag,
  'reflectivos-y-de-precaucion': TbTrafficCone,
  relojes: TbClock,
  sublimacion: TbPalette,
  tecnologia: TbDevices,
  variedades: TbBox,
  ya: TbBolt,
};

/**
 * Imagen de categoría sobre un círculo rosado claro: la foto de un producto real
 * (`imageUrl`, la `image_url` de la categoría) o, si no hay o no carga, el ícono en rojo En Stock.
 * @param {'lg'|'sm'} size  lg = página de categorías, sm = etiquetas/chips.
 */
const CategoryIcon = ({ slug, imageUrl, size = 'lg', className = '' }) => {
  const [failed, setFailed] = useState(false);
  const Icon = ICONS[slug] || TbBox;
  const showPhoto = imageUrl && !failed;
  return (
    <span
      className={`CategoryIcon CategoryIcon--${size}${showPhoto ? ' CategoryIcon--photo' : ''} ${className}`.trim()}
      aria-hidden="true"
    >
      {showPhoto
        ? <img className="CategoryIcon__photo" src={imageUrl} alt="" loading="lazy" onError={() => setFailed(true)} />
        : <Icon className="CategoryIcon__glyph" />}
    </span>
  );
};

export default CategoryIcon;
